import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { getWeddingPageByTypeV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import { getTravelType, getTravelIcon } from '../../manage/website/entities/TravelTypes';
import Address from '../../common/ui/Address';
import { chunkArray } from '../../common/ui/templateHelpers';

class Travel extends Component {
  componentDidMount() {
    const { getTravelEntities, forPreview } = this.props;
    if (!forPreview) {
      getTravelEntities();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  render() {
    const { travelEntities, orderedIds, page, forPreview, busy, wedding } = this.props;
    return (
      <div id="travel-page" className="container">
        {page && !busy && travelEntities && (
          <div>
            <div
              className={[
                'cms-page-header',
                (!page.description && !page.header_image_url) || !page.title
                  ? 'flex-container'
                  : null,
              ].join(' ')}
            >
              <div className="cms-header-accent-top-left" />
              <div className="cms-header-accent-top-right" />
              <div className="cms-header-accent-bottom-left" />
              <div className="cms-header-accent-bottom-right" />
              <h1 className="for-small-laptops">{page.title}</h1>
              {window.zola.env !== 'production' ? (
                <span>
                  {page.header_image_url && (
                    <img
                      src={`${page.header_image_url}?h=400`}
                      alt={`The Wedding Website of ${wedding.owner_first_name} ${wedding.owner_last_name} and ${wedding.partner_first_name} ${wedding.partner_last_name}`}
                      className="img-responsive center-block"
                    />
                  )}
                </span>
              ) : (
                <span>
                  {page.header_image_url && (
                    <img
                      src={`${page.header_image_url}?h=400`}
                      alt={page.title}
                      className="img-responsive center-block"
                    />
                  )}
                </span>
              )}
              {page.description && (
                <p
                  className={[
                    'page-description',
                    page.header_image_url ? 'has-image-above' : null,
                  ].join(' ')}
                >
                  {page.description}
                </p>
              )}
            </div>
            <div className="entity-sections travel-sections">
              <div className="entity-sections-accent-top-left" />
              <div className="entity-sections-accent-top-right" />
              <div className="entity-sections-accent-bottom-left" />
              <div className="entity-sections-accent-bottom-right" />
              {forPreview &&
                travelEntities &&
                chunkArray(orderedIds, 2).map((travelIdsChunk, idx) => (
                  <div className="entity-section-row" key={idx}>
                    {travelIdsChunk.map(travelId => (
                      <div key={travelId} className="entity-section travel-section">
                        <div className="entity-section-title travel-section-title">
                          <i
                            className={`zolaicon-public zolaicon-public-${getTravelIcon(
                              travelEntities[travelId].type
                            ).toLowerCase()}`}
                          />
                          <h2 className="travel-name">{travelEntities[travelId].name}</h2>
                          <h4 className="travel-type">
                            {getTravelType(travelEntities[travelId].type)}
                          </h4>
                        </div>
                        <div className="entity-section-description travel-section-description">
                          <Address
                            address1={travelEntities[travelId].address_1}
                            address2={travelEntities[travelId].address_2}
                            city={travelEntities[travelId].city}
                            state={travelEntities[travelId].state_province}
                            zip={travelEntities[travelId].postal_code}
                            countryCode={travelEntities[travelId].country_code}
                          />
                          {travelEntities[travelId].contact_phone && (
                            <p className="contact-phone">
                              {travelEntities[travelId].contact_phone}
                            </p>
                          )}
                          {travelEntities[travelId].start_at && (
                            <p className="schedule-date">
                              {moment.utc(travelEntities[travelId].start_at).format('MMMM D, YYYY')}{' '}
                              <br />
                              {moment
                                .utc(travelEntities[travelId].start_at)
                                .format('h:mm a')} -{' '}
                              {moment.utc(travelEntities[travelId].end_at).format('h:mm a')}
                            </p>
                          )}
                          {travelEntities[travelId].note && (
                            <p className="travel-note">{travelEntities[travelId].note}</p>
                          )}
                          {travelEntities[travelId].code && (
                            <p className="travel-note">
                              Discount Code - {travelEntities[travelId].code}
                            </p>
                          )}
                          {travelEntities[travelId].url && (
                            <div>
                              <a
                                href={travelEntities[travelId].url}
                                className="btn btn-primary btn-wide"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              {!forPreview &&
                travelEntities &&
                chunkArray(travelEntities, 2).map((travelIdsChunk, idx) => (
                  <div className="entity-section-row" key={idx}>
                    {travelIdsChunk.map((travel, i) => (
                      <div key={i} className="entity-section travel-section">
                        <div className="entity-section-title travel-section-title">
                          <i
                            className={[
                              'zolaicon-public zolaicon-public-',
                              `${travel.type ? travel.type.toLowerCase() : 'plane'}`,
                            ].join('')}
                          />
                          <h2 className="travel-name">{travel.name}</h2>
                          <h4 className="travel-type">{getTravelType(travel.type)}</h4>
                        </div>
                        <div className="entity-section-description travel-section-description">
                          <Address
                            address1={travel.address_1}
                            address2={travel.address_2}
                            city={travel.city}
                            state={travel.state_province}
                            zip={travel.postal_code}
                            countryCode={travel.country_code}
                          />
                          {travel.contact_phone && (
                            <p className="contact-phone">{travel.contact_phone}</p>
                          )}
                          {travel.start_at && (
                            <p className="schedule-date">
                              {moment.utc(travel.start_at).format('MMMM D, YYYY')} <br />
                              {moment.utc(travel.start_at).format('h:mm a')} -{' '}
                              {moment.utc(travel.end_at).format('h:mm a')}
                            </p>
                          )}
                          {travel.note && <p className="travel-note">{travel.note}</p>}
                          {travel.code && (
                            <p className="travel-note">Discount Code - {travel.code}</p>
                          )}
                          {travel.url && (
                            <div>
                              <a
                                href={travel.url}
                                className="btn btn-primary btn-wide"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View
                              </a>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              {((forPreview && orderedIds && orderedIds.length === 0) ||
                (!forPreview && travelEntities && travelEntities.length === 0)) && (
                <p className="text-center empty-entity-text">
                  We&#39;re working on gathering some recommendations for our out-of-towner guests.
                  Stay tuned!
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}

Travel.propTypes = {
  travelEntities: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  getTravelEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  busy: PropTypes.bool,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  }),
};

const mapStateToProps = (state, ownProps) => ({
  travelEntities: ownProps.forPreview ? state.website.entities.byId : state.publicWebsite.entities,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  busy: state.publicWebsite.busy,
  wedding: state.publicWebsite.wedding,
});

const mapDispatchToProps = dispatch => ({
  getTravelEntities: () => {
    dispatch(getWeddingPageByTypeV2('travel'));
  },
  unloadEntities: () => {
    dispatch(resetEntities());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Travel);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Travel.jsx